import { useEffect } from "react"

export default function PaginationAdjustor({ setTableOptions, children }) {
    useEffect(() => {
        const handleResize = () => {
            const targetRowPerPages = window?.innerWidth >= 768 ? 100 : 50
            setTableOptions((prev) => {
                if (prev?.rowPerPages == targetRowPerPages) return prev
                return { ...prev, rowPerPages: targetRowPerPages }
            })
        }

        window.addEventListener('resize', handleResize)
        return () => window.removeEventListener('resize', handleResize)
    }, [])

    return <>{children}</>
}
